import { Typography } from "antd"
import cls from "classname"

import Icon from "../../../../Icon"

import "./LostLegacyNotification.less"

const { Text } = Typography

const LostLegacyNotification = ({ fullWidth }) => {
  return (
    <div className={cls("alert-warning-notification", { "full-width": fullWidth })}>
      <Icon className="icon" type="triangle_exclamation2" />
      <Text strong>
        "Lost" is now called "Expired". Older log entries still use the previous name.
      </Text>
    </div>
  )
}

export default LostLegacyNotification
